export class MaterialPurchaseHistory {
  fkINCo?: number;
  fkMaterial?: string;
  vendorGroup?: number;
  vendor?: number;
  vendorName?: string;
  poItem?: number;
  curUnitCost?: number;
  origUnitCost?: number;
  origUnits?: number;
  orderDate?: Date;
  po?: string;
}
